import isIdentityCard from 'validator/lib/isIdentityCard';

export const checkValidEmail = email => {
	const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	return re.test(email) && !/\'|\"|\\|\//.test(email);
};
export const checkValidNumbersLetters = name => {
	const re = /^[0-9a-zA-Z]+$/;
	return re.test(name);
};
export const checkValidPhone = phone => {
	const re = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im;
	return re.test(phone);
};
export const checkValidPosition = position => {
	const re = /^[a-zA-ZÀ-ÿ\u00f1\u00d1]+$/;
	return re.test(position);
};
export const checkValidNumbers = numParticipations => {
	const re = /^[0-9]+$/;
	return re.test(numParticipations);
};

const idCardLocales = {
	es: 'ES',
	cat: 'ES',
	gal: 'ES',
	vl: 'ES',
	eu: 'ES'
};

const checkNIE = (nie = '') => {
	let number;
	if ('XYZ'.includes(nie.charAt(0))) {
		number = nie.replace(nie.charAt(0), 'XYZ'.indexOf(nie.charAt(0)));
	}
	if (number) {
		return isIdentityCard(number, 'ES');
	}

	return false;
};

const checkDNI = (dni = '', country = 'ES') => isIdentityCard(dni, country);

export const checkNIF = (nif = '', locale = 'es') => {
	const country = idCardLocales[locale];

	if (!country) {
		return true;
	}

	if (checkDNI(nif, country)) {
		return true;
	}
	if (checkNIE(nif)) {
		return true;
	}
	return false;
};
